/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Button, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { CustomerModel } from "../../Utils/Models";
import { handleChangeAutocomplete } from "../../Utils/Utils";
import { Add } from "@mui/icons-material";
import CustomerMainPage from "../Customers/CustomerMainPage";
import { updateData } from "../../Services/updateData";
import { postData } from "../../Services/postData";
import { CheckInOrderProps } from "./CheckInMainPage";
import { OrderContext } from "../../Contexts/OrderContext";
import { TemplatesType } from "../../Utils/AutocompleteUtils";
import DividerWithLabel from "../GenericComponents/DividerWithLabel";
import PreviewPDF from "../GenericComponents/PDFViewer";

export type CheckInPagesProps = {
  checkInOrder: CheckInOrderProps;
  handleChangeCheckInOrder: (checkInOrder: CheckInOrderProps) => void;
};
export default function CheckInCustomer(props: CheckInPagesProps) {
  const { checkInOrder, handleChangeCheckInOrder } = props;
  const orderContext = useContext(OrderContext);
  const [customers, setCustomers] = useState([]);
  const [open, setOpen] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);

  /**
   *
   */
  useEffect(() => {
    getCustomers();
  }, []);

  /**
   *
   */
  function getCustomers() {
    getData(urlEnum.customerCrm).then((res: any) => {
      if (res.data.status === 200) setCustomers(res.data.result);
    });
  }

  /**
   *
   * @param step
   */
  function addOrUpdateCustomer(customer: CustomerModel | null) {
    if (customer?._id) {
      updateData(`${urlEnum.customerCrm}/${customer._id}`, customer)
        .then((res) => {
          if (res) {
            setOpen(false);
            getCustomers();
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    } else {
      postData(urlEnum.customerCrm, customer)
        .then((res: any) => {
          if (res) {
            setOpen(false);
            getCustomers();
          }
        })
        .catch((err) => {
          setOpen(false);
        });
    }
  }

  /**
   *
   */
  async function generatePDF() {
    const res = await postData(`${urlEnum.documents}/generatePdf`, {
      customerId: checkInOrder.customer?._id,
      orderId: orderContext.order._id,
      documentType: TemplatesType.gdpr,
    });
    if (res) {
      handleChangeCheckInOrder({
        ...checkInOrder,
        gdpr: res.data,
      });
      setOpenPDF(true);
    }
  }

  /**
   *
   * @param signature
   */
  async function saveSignature(signature: any) {
    const formData = new FormData();
    formData.append("signature", signature.blobSignature);
    formData.append("customerId", checkInOrder.customer?._id || "");
    formData.append("orderId", orderContext.order._id || "");
    formData.append("documentType", TemplatesType.gdpr);

    const url = `${urlEnum.documents}/generatePdf`;

    const res = await postData(url, formData);
    if (res) {
      handleChangeCheckInOrder({
        ...checkInOrder,
        gdpr: res.data,
      });
    }
  }

  /**
   *
   * @param body
   */
  async function sendEmail(body: any) {
    await postData(
      `${urlEnum.orders}/sendEmailForGDPR/${orderContext.order._id}/${checkInOrder.customer?._id}`,
      body
    );
  }

  return (
    <div style={{ margin: "10px 0px" }}>
      <Typography
        style={{
          fontSize: 20,
          fontWeight: 400,
          marginBottom: 15,
          textAlign: "center",
        }}
      >
        {Vocabulary.chooseOrAddCustomer}
      </Typography>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Autocomplete
          size="small"
          id="customer"
          freeSolo={false}
          disablePortal
          getOptionLabel={(option: any) =>
            `${option.name || option.company}`
          }
          isOptionEqualToValue={(option: any, value: any) =>
            option._id === value._id
          }
          options={customers}
          value={checkInOrder.customer}
          onChange={(event: any, value: any) => {
            handleChangeCheckInOrder(
              handleChangeAutocomplete(event, value, checkInOrder, "customer")

            );
          }}
          fullWidth
          renderInput={(params) => (
            <TextField
              {...params}
              name="customer"
              label={Vocabulary.customer}
              variant="outlined"
            />
          )}
        />
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            setOpen(true);
          }}
          style={{ marginLeft: 15 }}
        >
          {Vocabulary.add}
        </Button>
      </div>
      {/* GDPR */}
      <DividerWithLabel
        label={Vocabulary.gdpr}
        styles={{ margin: "15px 0px" }}
      />
      {checkInOrder.gdpr ? (
        <div
          style={{
            padding: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p>{checkInOrder.gdpr?.fileName}</p>
          <Button variant="contained" onClick={() => setOpenPDF(true)}>
            {Vocabulary.open}
          </Button>
        </div>
      ) : (
        <Button
          variant="contained"
          disabled={checkInOrder.customer ? false : true}
          onClick={() => generatePDF()}
        >
          {Vocabulary.generateGDPR}
        </Button>
      )}
      {open ? (
        <CustomerMainPage
          editCustomer={null}
          open={open}
          addOrUpdateCustomer={(customer) => addOrUpdateCustomer(customer)}
          onClose={() => setOpen(false)}
          fromOrder={false}
        />
      ) : null}
      {openPDF ? (
        <PreviewPDF
          title={checkInOrder.gdpr?.fileName || ""}
          open={openPDF}
          onClose={() => {
            setOpenPDF(false);
          }}
          emailData={{
            to: checkInOrder.customer?.email || "",
            subject: "Semnarea acordului GDPR",
            message: "GDPR",
            docPath: checkInOrder.gdpr?.fileName || "",
          }}
          isSign={checkInOrder.gdpr?.isSigned}
          url={`${urlEnum.documents}/getPdf/templatesDocs/${checkInOrder.gdpr?.fileName}`}
          saveSignature={(signature) => saveSignature(signature)}
          sendEmail={(body: any) => sendEmail(body)}
        />
      ) : null}
    </div>
  );
}
